<template>
  <div class="full-indicators-info">
    <div>
      <router-link to="/indicators/region">
        <v-btn>Назад</v-btn>
      </router-link>
    </div>
    <table class="full-indicators-info__table full-indicators-info__table-region">
      <thead>
      <tr>
        <th style="border-bottom: 0"></th>
        <th style="grid-column: span 3; border-bottom: 0">Распределение КЦП</th>
        <th style="grid-column: span 3; border-bottom: 0">Оценка заявки</th>
      </tr>
      <tr>
        <th>Образовательная организация. УГСН (НПС)</th>
        <th>Очная форма</th>
        <th>Очно-заочная форма</th>
        <th>Заочная форма</th>
        <th>Очная форма</th>
        <th>Очно-заочная форма</th>
        <th>Заочная форма</th>
      </tr>
      </thead>
      <tbody>
      <template v-if="!loading">
        <tr v-for="(item) in serverData" :key="calcIdRow(item)">
          <td v-if="item.orgFlag" class="full-indicators-info__table-org" colspan="4">{{ item.orgName }}</td>
          <td v-else-if="item.uslName" class="full-indicators-info__table-usl" colspan="4">{{ item.uslName }}</td>
          <template v-else>
            <td>
              <span class="kcp-code">{{ item.kcpGroup.code }}</span>
              <span class="kcp-name">{{ item.kcpGroup.name }}</span>
            </td>
            <td
              class="kcp-percent-scale__stage-one justify-center"
              :class="{'kcp-percent-scale__disabled': item.qkcpo24 === null}"
            >
              <div class="d-block text-center ww-100 hh-100" style="position: relative">
                <span class="d-flex align-center  justify-center hh-100">
                  {{ showingValue(item, 'qkcpo24') }}
                </span>
                <span class="tooltip-indicators-decline"></span>
              </div>
            </td>
            <td
              class="kcp-percent-scale__stage-one justify-center"
              :class="{'kcp-percent-scale__disabled': item.qkcpv24 === null}"
            >
              <div class="d-block text-center ww-100 hh-100" style="position: relative">
                <span class="d-flex align-center  justify-center hh-100">
                  {{ showingValue(item, 'qkcpv24') }}
                </span>
                <span class="tooltip-indicators-decline"></span>
              </div>
            </td>
            <td
              class="kcp-percent-scale__stage-one justify-center"
              :class="{'kcp-percent-scale__disabled': item.qkcpz24 === null}"
            >
              <div class="d-block text-center ww-100 hh-100" style="position: relative">
                <span class="d-flex align-center  justify-center hh-100">
                  {{ showingValue(item, 'qkcpz24') }}
                </span>
                <span class="tooltip-indicators-decline"></span>
              </div>
            </td>
            <td @click="openScore(item.id, 1, 1, item.iokio, item.kcpGroup.usl.id, item.kcpGroup, item.orgId)"
                class="kcp-percent-scale" :class="{'kcp-percent-scale__disabled': item.iokio === null}"
                :style="calcBackground(item.iokio,item.iowgt)">
              {{ showingValue(item, 'iokio') }}
            </td>
            <td @click="openScore(item.id, 1, 2, item.iokiv, item.kcpGroup.usl.id, item.kcpGroup, item.orgId)"
                class="kcp-percent-scale" :class="{'kcp-percent-scale__disabled': item.iokiv === null}"
                :style="calcBackground(item.iokiv,item.iowgt)">
              {{ showingValue(item, 'iokiv') }}
            </td>
            <td @click="openScore(item.id, 1, 3, item.iokiz, item.kcpGroup.usl.id, item.kcpGroup, item.orgId)"
                class="kcp-percent-scale" :class="{'kcp-percent-scale__disabled': item.iokiz === null}"
                :style="calcBackground(item.iokiz,item.iowgt)">
              {{ showingValue(item, 'iokiz') }}
            </td>
          </template>
        </tr>
      </template>
      <template v-else>
        <tr>
          <td class="full-indicators-info__table-org" rowspan="4" colspan="4">
            <v-progress-linear indeterminate></v-progress-linear>
          </td>
        </tr>
      </template>
      </tbody>
    </table>
    <confirm-dialog ref="agree-dialog" text="Вы уверены?"/>
  </div>
</template>

<script>
import {calcBackground} from "@/utils/indicators";
import {getAllGroupedKcpIndicatorsStage1Regions} from "@/api/indicatorsRegion";
import ConfirmDialog from "@/components/Dialogs/confirmDialog";
// import {mapActions} from "vuex";


export default {
  name: "AllListStage1Region",
  components: {ConfirmDialog},
  data() {
    return {
      serverData: [],
      loading: false
    }
  },
  created() {
    // this.replaceId(this.$route.query.orgId);
    this.getServerData();
  },
  computed: {
    orgId() {
      return this.$route.query?.orgId
    },
    regionId() {
      return this.$route.query?.regionId
    }
  },
  methods: {
    // ...mapActions('auth', {getUserInfo: 'getUserInfo', replaceId: 'replaceId'}),
    async getServerData() {
      try {
        this.loading = true;
        this.serverData = await getAllGroupedKcpIndicatorsStage1Regions(this.orgId, this.regionId);
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    calcBackground(value, maxValue, minValue = 0) {
      return calcBackground(value, maxValue, minValue)
    },
    openScore(rowId, s0b, appForm, score, usl, kcp, org) {
      const {id, code, name} = kcp;
      if (score !== null)
        this.$router.push({
          path: '/indicators/details',
          query: {fo: appForm, id: rowId, kcpId: id, code: code, name: name, value: score, usl: usl, org: org}
        })
    },
    showingValue(item, dataField) {
      return item[dataField] == null ? 'нет заявки' : item[dataField]
    },
    calcIdRow(item) {
      return item.kcpGroup?.id ? Math.random() + '-' + (item.kcpGroup.id + '-' + item.kcpGroup.usl.id + '-' + item.orgId) : (Math.random() + '-' + item.orgId)
    }
  },
}
</script>

<style lang="sass" scoped>
.tooltip-indicators-decline
  display: block
  position: absolute
  right: 0
  top: 0

</style>